import "react-app-polyfill/ie11";
import "react-app-polyfill/ie9";
import '@gaf/typescript-authentication-okta/polyfill';

import "core-js/stable";
import * as React from "react";
import "babel-polyfill";
import "bootstrap";
import "jquery";
import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { createBrowserHistory } from "history";
import configureStore from "./configureStore";
import { ApplicationState } from "./reducers";
import * as RoutesModule from "./routes";
import AppTracking from '../AppTracking';
import '../AppTracking/appInsights';

import "../assets/sass/index.scss";
import { StrictMode } from "react";

let routes = RoutesModule.routes;

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href")!;
const history = createBrowserHistory({ basename: baseUrl });

history.listen(() => {
    window['AppInsightTrace'].trackPageView();
    AppTracking.updateTrackingId();
});



// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = (window as any).initialReduxState as ApplicationState;
const store = configureStore(history, initialState);

function renderApp() {
    return ReactDOM.render(
        <Provider store={store}>
            <ConnectedRouter history={history} children={routes} />
        </Provider>,
        document.getElementById("react-app")
    );
}
renderApp();



if (module.hot) {
    module.hot.accept("./routes", function () {
        routes = require<typeof RoutesModule>("./routes").routes;
        renderApp();
    }); /* eslint-disable-line no-undef */
}
